import React, { PropsWithChildren } from "react";
import LoadingIndicator from "../loading/LoadingIndicator";
import { Helmet } from "react-helmet";
import { useCustomTranslation } from "../../helpers/translateHelpers";

interface Props {
  largePadding?: boolean;
  small?: boolean;
  loading?: boolean;
  htmlTitle?: string;
}

const ContentWrapper: React.FC<PropsWithChildren<Props>> = (
  props,
): React.ReactElement => {
  const { tCommon } = useCustomTranslation();

  const title = props.htmlTitle
    ? `${props.htmlTitle} - ${tCommon("customer_portal")}`
    : tCommon("customer_portal");

  return (
    <>
      <Helmet title={title} />
      <div
        className={`rounded-2xl bg-white p-6 ${props.largePadding ? "sm:p-20" : "sm:p-10"} ${
          props.small ? "sm:w-[640px]" : "sm:w-[1000px]"
        } mt-4 mb-4 sm:mt-12 sm:mb-13`}
      >
        {props.loading ? <LoadingIndicator /> : props.children}
      </div>
    </>
  );
};

export default ContentWrapper;
